var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ReferenceHandler',{on:{"entryClicked":_vm.entryClicked}},[_c('Content',{attrs:{"slice":_vm.replacedText}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }